import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
import { getStorageUser } from '../../../helpers/api_helper';
import {Alert,ConfirmAsistencia} from '../../../helpers/alerts/alertHelper';
import { resourcesAttendances } from '../../../helpers/backend_helper';

const Columns = (attendanceModal,setAttendanceModal,setFilters,filters,datesDays) => {
	const days=[
		'Domingo',
		'Lunes',
		'Martes',
		'Miercoles',
		'Jueves',
		'Viernes',
		'Sabado',
		];

	const changeStatus = (date,id,status) => {
    	let data = {
			date:date,
			id:id,
			attendance:status
	    }
    	ConfirmAsistencia(async confirmed => {
            if (!confirmed) { return; }
            resourcesAttendances('post',data).then(response => {
    			setFilters({...filters,week:filters.week})
    		})
        },status);
    }

	let col = [
		{
			id: 'number',
			name: 'Unidad',
			selector: row => `${row.number}`,
			sortable: true,
			minWidth:'100px'
		},
	]
//item:row,date:row.days['Domingo'].date,day:'Domingo'}
	days.map(d=>(
		col.push({
			id: d,
			name: (<>{d == 'Miercoles' ? 'Miércoles' : (d == 'Sabado'?'Sábado':d)}<br />{datesDays[d]}</>),
			minWidth:'120px',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						{
							row[d]
						}
					</div>
				</div>
			),
		})
	))

	col.push(
		{
			id: 'weekIncome',
			name: 'Monto',
			selector: row => row.weekIncome,
			minWidth:'120px'
		},
	)

	

	let columns = col
	return columns;
}

export default Columns;